<template>
	<div class="row principal"></div>
</template>
<script lang="ts">

	export default 
	{
		name: "DTEManual",
		props: {
			menu: String
		},
		data() {
			return {
				flag: true,
			}
		},
	}

</script>
<style scoped>

	.principal {
		width: 100%;
		margin-right: 0 !important;
		margin-left: 0 !important;
	}

</style>
